/* =========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' // Material Icons
import 'vuesax/dist/vuesax.css'

// i18n
import VueI18n from 'vue-i18n'

// i18n
import i18n from './i18n/i18n'

// days
import * as dayjs from 'dayjs'
import * as relativeTimePlugin from 'dayjs/plugin/relativeTime'

// axios
import axios from './axios.js'

// Filters
import './filters/filters.js'

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import { getToken } from '@/sessionStorage'

// cookies
import VueCookies from 'vue-cookies'

Vue.use(new VueSocketIO({
  debug: false,
  connection: SocketIO.connect(process.env.VUE_APP_SOCKET_URL || '', {
    extraHeaders: {
      token: getToken()
    },
    autoConnect: true
  }),
  vuex: {
    store
  }
})
) // Vuesax
Vue.use(Vuesax)
Vue.use(VueI18n)
require('dayjs/locale/es')
require('dayjs/locale/en')
dayjs.locale(i18n.locale)
dayjs.extend(relativeTimePlugin)
Vue.prototype.$dayjs = dayjs
Vue.prototype.$http = axios
Vue.use(VueHammer)
Vue.use(VueCookies)
Vue.$cookies.config('1d', null, null, null, true, 'Strict')

// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

export const messages = async () => {
  const es = await axios({ url: `${process.env.VUE_APP_LANG_URL}/es.json`, method: 'GET' }).then(res => res.data).catch(err => console.log(err))
  const en = await axios({ url: `${process.env.VUE_APP_LANG_URL}/en.json`, method: 'GET' }).then(res => res.data).catch(err => console.log(err))

  i18n.setLocaleMessage('en', en)
  i18n.setLocaleMessage('es', es)
  return {
    en,
    es
  }
}

export const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
